export const SHOPPING_CART_TOKEN_COOKIE_KEY = 'vp_shoppingCartToken_27b70d';
